import { React, Component } from "react";
import Sidebar from "./Sidebar";
import RightSidebar from "./RightSidebar";
import "bootstrap/dist/css/bootstrap-grid.min.css";
import "./CSSFiles/Dashboard.css";
import NotificationsFeed from "../../Notifications/NotificationsFeed";

class NotificationsHome extends Component {
  render() {
    return (
      <div className="app">
        <div className="app-body">
          <div className="container dashboardInnerContainer">
            <div className="row dashboard">
              <div className="col-xs-0 col-sm-0 col-md-3">
                <Sidebar />
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 dashboardFeedMiddleRow">
                <NotificationsFeed />
              </div>
              <div className="col-xs-0 col-sm-0 col-md-3">
                <RightSidebar />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NotificationsHome;
